export enum YesNoFormValue {
  YES = 'yes',
  NO = 'no'
}

export type AutocompleteOption<TValue extends string = string> = {
  id: TValue
  label: string
}

export type YesNoItemWithCommentFormValues = {
  value: YesNoFormValue
  comment?: string
}

export type YesNoItemWithRetakeAndCommentFormValues = {
  value: YesNoFormValue
  valueRetake: YesNoFormValue
  comment: string
}
